import type {
  TherapistApi,
  TherapistLevelApi,
  TherapistUpdateApiQuery,
  TherapistStripeAccountApi,
  TherapistUpdateCurrentApiQuery,
  TherapistCreateEducationApiQuery,
  TherapistDeleteEducationApiQuery,
  TherapistUpdateEducationApiQuery,
  TherapistActionApiQuery,
  TherapistEducationApi,
} from "@/Modules/Models/Api/Therapist";

import { get2, post2, patch2, remove2 } from "./utils/FunctionalTherapyApi";

class TherapistApiConnector {
  constructor() {}

  get(): Promise<TherapistApi> {
    return get2<void, TherapistApi>("/v1.0/therapists/me");
  }

  getLevel(): Promise<TherapistLevelApi> {
    return get2<void, TherapistLevelApi>("/v2.0/therapist_level/me");
  }

  update(updateQuery: TherapistUpdateApiQuery): Promise<TherapistApi> {
    return patch2<TherapistUpdateApiQuery, TherapistApi>("/v1.0/therapists/me", updateQuery);
  }

  updateStripeAccount(): Promise<TherapistStripeAccountApi> {
    return post2("/v1.0/therapists/me/stripe-account");
  }

  updateTherapistCurrents(
    currents: TherapistUpdateCurrentApiQuery[]
  ): Promise<TherapistUpdateCurrentApiQuery[]> {
    return patch2<TherapistUpdateCurrentApiQuery[], TherapistUpdateCurrentApiQuery[]>(
      "/v1.0/therapists/me/currents",
      currents
    );
  }

  createTherapistEducation(
    createEducationApiQuery: TherapistCreateEducationApiQuery
  ): Promise<TherapistEducationApi> {
    return post2<TherapistCreateEducationApiQuery, TherapistEducationApi>(
      "/v1.0/therapists/me/educations",
      createEducationApiQuery
    );
  }

  updateTherapistEducation(
    updateEducationApiQuery: TherapistUpdateEducationApiQuery
  ): Promise<TherapistEducationApi> {
    return patch2<TherapistUpdateEducationApiQuery, TherapistEducationApi>(
      "/v1.0/therapists/me/educations",
      updateEducationApiQuery
    );
  }

  deleteTherapistEducation(deleteEducationApiQuery: TherapistDeleteEducationApiQuery): Promise<void> {
    return remove2<TherapistDeleteEducationApiQuery, void>(
      "/v1.0/therapists/me/educations",
      deleteEducationApiQuery
    );
  }

  setTherapistAction(action: TherapistActionApiQuery): Promise<void> {
    return patch2<TherapistActionApiQuery, void>("/v1.0/therapists/me/action", action);
  }
}

export default TherapistApiConnector;
